export default "__VITE_ASSET__UZgEG9Zb__"